<template>
  <div class="facility-area-box">
    <span class="box-title">避難元所属市町村・地域（地区）</span>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0 facility-area-table"
      locale="ja-jp"
      hide-default-footer
      hide-default-header
      item-key="key"
      no-data-text=""
      :items-per-page="500"
    >
      <template v-slot:[`item.eva_municip_code`]="{ item }">
        <v-select
          :items="municipalities"
          v-model="item.eva_municip_code"
          v-bind="$formControlProps(readOnly)"
          label="避難元所属市町村 ※"
          :placeholder="config.PLACEHOLDER_SELECT"
          @change="changeMunicipality(item)"
          :error-messages="errorMunicipality(item)"
        ></v-select>
      </template>
      <template v-slot:[`item.eva_area_code`]="{ item }">
        <v-select
          :items="areasForEdit[item.key]"
          v-model="item.eva_area_code"
          v-bind="$formControlProps(readOnly)"
          label="避難元所属地域（地区） ※"
          :placeholder="config.PLACEHOLDER_SELECT"
          :error-messages="errorArea(item)"
        ></v-select>
      </template>
      <template v-slot:[`item.actions`]>
        <v-btn class="mx-2" color="primary" v-if="!readOnly" @click="addItem"
          >追加</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import maxBy from "lodash/maxBy";
import minBy from "lodash/minBy";
import config from "@/js/const";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
export default {
  name: "EvaAreaInfo",
  data: () => ({
    config: config,
    items: [],
    areasForEdit: []
  }),
  props: {
    evaAreaInfo: {
      type: Array,
      default: () => []
    },
    editedEvaAreaInfo: {
      type: Array,
      default: () => []
    },
    municipalities: {
      type: Array,
      default: () => []
    },
    areas: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean
    },
    facilityClass: {
      type: String
    },
    facilityId: {
      type: String
    }
  },
  watch: {
    items: {
      handler: function(newItems) {
        this.$emit("update:editedEvaAreaInfo", newItems);
      },
      deep: true
    },
    facilityId: "initialize"
  },
  mounted() {
    this.initialize();
  },
  computed: {
    headers() {
      return [
        {
          text: "避難元所属市町村",
          value: "eva_municip_code",
          sortable: false
        },
        {
          text: "地域（地区）",
          value: "eva_area_code",
          sortable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  methods: {
    initialize() {
      if (this.editedEvaAreaInfo.length == 0) {
        this.items = cloneDeep(this.evaAreaInfo);
      } else {
        this.items = cloneDeep(this.editedEvaAreaInfo);
      }
      this.items.forEach(item => {
        this.changeMunicipality(item, false);
      });
    },
    addItem() {
      const maxItem = maxBy(this.items, "key");
      this.items.push({
        key: maxItem.key + 1,
        eva_municip_code: "",
        eva_area_code: ""
      });
    },
    changeMunicipality(item, isClearArea = true) {
      this.areasForEdit[item.key] = AllAreaTranslator.toAreasByMunicipality(
        this.areas,
        item.eva_municip_code
      );
      if (isClearArea) {
        Object.assign(item, { eva_area_code: "" });
      }
    },
    errorMunicipality(item, items = this.items) {
      const minItem = minBy(items, "key");
      if (item.key === minItem.key && !item.eva_municip_code) {
        return "必須項目です。";
      }
      return "";
    },
    errorArea(item, items = this.items) {
      const minItem = minBy(items, "key");
      if (item.key === minItem.key && !item.eva_area_code) {
        return "必須項目です。";
      }
      if (item.eva_municip_code && !item.eva_area_code) {
        return "必須項目です。";
      }
      if (!item.eva_municip_code && !item.eva_area_code) {
        return "";
      }
      const hasItem = items.some(data => {
        return (
          item.key !== data.key &&
          item.eva_municip_code === data.eva_municip_code &&
          item.eva_area_code === data.eva_area_code
        );
      });
      if (hasItem) {
        return "重複しています。";
      }
      return "";
    },
    validate() {
      let validate = true;
      this.editedEvaAreaInfo.forEach(item => {
        if (
          this.errorMunicipality(item, this.editedEvaAreaInfo) !== "" ||
          this.errorArea(item, this.editedEvaAreaInfo) !== ""
        ) {
          validate = false;
          return false;
        }
      });
      return validate === true;
    }
  }
};
</script>
